import './header.scss';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { isNull } from 'lodash';
import { IRootState } from 'app/shared/reducers';

export interface IHeaderProps {
  languagesList: any;
}

const Header = (props: IHeaderProps) => {
  const [toggleDropdown,setToggleDropdown] = useState(false);
  const [valueDropdown, setValueDropdown] = useState(isNull(localStorage.getItem('language')) ? 'FR' : localStorage.getItem('language').toUpperCase());

  const toggle = () =>{
    setToggleDropdown(prevState =>  !prevState);
  }
  const selectLangue = (language) => {
    localStorage.setItem('language', language);
    setValueDropdown(language)
    window.location.reload();
  }
  /* jhipster-needle-add-element-to-menu - JHipster will add new menu items here */

  return (
    <div id="app-header">
        {props.languagesList.length > 1 &&
          <Dropdown className="my-dropdown" isOpen={toggleDropdown} toggle={toggle} >
            <DropdownToggle caret>
              <img style={{ width: "20px" }} src={"/content/images/flags/" + valueDropdown + ".svg"} />
            </DropdownToggle>
            <DropdownMenu className="my-dropdown dropdown-menu">
              {props.languagesList.map((language, key) => {
                return <DropdownItem key={key} onClick={(e) => selectLangue(language)}>{language} &nbsp;<img style={{ width: "20px" }} src={"/content/images/flags/" + language + ".svg"} /></DropdownItem>
              })}
            </DropdownMenu>
          </Dropdown>
        }

    </div>
  );
};

export default Header;
